import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router'
import { SessionContext } from 'data/context';

export const PrivateRoute = ({ component: Component, dealers, setDateRange, dateRange, ...rest }) => {
  const role = useContext(SessionContext).ftusertype;
  
  return <Route
    {...rest}
    render={props =>
      role !== '5' ? (
        <Component dealers={dealers} setDateRange={setDateRange} dateRange={dateRange} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/'
          }}
        />
      )
    }
  />
}
